import {
  PriceElementPeriodSavingMobileUi,
  PriceElementPeriodSavingWrapperMobileUi,
  PricePlanMobileSwitcherSliderUi,
  PricePlanMobileSwitcherToggleButtonUi,
  PricePlanMobileSwitcherToggleUi,
  PricePlanMobileSwitcherUi,
} from 'common/components/entities/price-element/price-element-period/ui/price-plan-mobile-button'
import {
  PriceElementPeriodSavingUi,
  PriceElementPeriodSwitcherLabelUi,
  PriceElementPeriodSwitcherUi,
  SwitchInputUi,
  SwitchLabelUi,
  SwitchSliderUi,
} from 'common/components/entities/price-element/price-element-period/ui/price-plan-switcher-ui'
import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

export interface PricePlanSwitcherProps {
  isChecked: boolean
  onClick: () => void
}

export const PricePlanSwitcher = ({
  isChecked,
  onClick,
}: PricePlanSwitcherProps) => {
  const { t } = useTypedTranslation()

  return (
    <>
      <PricePlanMobileSwitcherUi>
        <PricePlanMobileSwitcherToggleUi>
          <PricePlanMobileSwitcherToggleButtonUi
            isSelected={!isChecked}
            onClick={onClick}
          >
            {t('components.price_element.period.monthly_billing')}
          </PricePlanMobileSwitcherToggleButtonUi>
          <PricePlanMobileSwitcherSliderUi isActive={isChecked} />
          <PricePlanMobileSwitcherToggleButtonUi
            isSelected={isChecked}
            onClick={onClick}
          >
            {t('components.price_element.period.annual_billing')}
          </PricePlanMobileSwitcherToggleButtonUi>
          <PriceElementPeriodSavingWrapperMobileUi>
            <PriceElementPeriodSavingMobileUi isVisible={isChecked}>
              {t('components.price_element.period.additional_text')}{' '}
              {t('components.price_element.period.sub_additional_text')}
            </PriceElementPeriodSavingMobileUi>
            <PriceElementPeriodSavingMobileUi isVisible={isChecked}>
              {t('components.price_element.plans.free_migration')}
            </PriceElementPeriodSavingMobileUi>
          </PriceElementPeriodSavingWrapperMobileUi>
        </PricePlanMobileSwitcherToggleUi>
      </PricePlanMobileSwitcherUi>

      <PriceElementPeriodSwitcherUi>
        <PriceElementPeriodSwitcherLabelUi isActive={!isChecked}>
          {t('components.price_element.period.monthly_billing')}
        </PriceElementPeriodSwitcherLabelUi>
        <SwitchLabelUi>
          <SwitchInputUi checked={isChecked} onClick={onClick} />
          <SwitchSliderUi />
        </SwitchLabelUi>
        <PriceElementPeriodSwitcherLabelUi isActive={isChecked}>
          {t('components.price_element.period.annual_billing')}
        </PriceElementPeriodSwitcherLabelUi>

        <PriceElementPeriodSavingUi isVisible={isChecked}>
          {t('components.price_element.period.additional_text')}{' '}
          {t('components.price_element.period.sub_additional_text')}
        </PriceElementPeriodSavingUi>
        <PriceElementPeriodSavingUi isVisible={isChecked}>
          {t('components.price_element.plans.free_migration')}
        </PriceElementPeriodSavingUi>
      </PriceElementPeriodSwitcherUi>
    </>
  )
}
